export default "__VITE_ASSET__D5IGBu0O__"